import { render, staticRenderFns } from "./EditSingleItem.vue?vue&type=template&id=56bf2589&scoped=true"
import script from "./EditSingleItem.vue?vue&type=script&lang=js"
export * from "./EditSingleItem.vue?vue&type=script&lang=js"
import style0 from "./EditSingleItem.vue?vue&type=style&index=0&id=56bf2589&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf2589",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bf2589')) {
      api.createRecord('56bf2589', component.options)
    } else {
      api.reload('56bf2589', component.options)
    }
    module.hot.accept("./EditSingleItem.vue?vue&type=template&id=56bf2589&scoped=true", function () {
      api.rerender('56bf2589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EditSingleItem.vue"
export default component.exports